module.exports = __webpack_public_path__ + "static/media/asset1.024e6bac.png";